// @flow
import * as React from 'react';
import { get, noop } from 'lodash';

import { ICONS } from 'Components/utils/icon/icons';

import FormSelect from 'Components/frameworks/form-select/FormSelect.jsx';
import { BookingFormBlockField as BlockField } from 'Components/widgets/booking-form/block-field/BlockField.jsx';

type departureCityItem = {
  name: string,
  value: string,
};

type Props = {
  departureCities: departureCityItem[],
  departureCity: string,
  setDepartureCity: string => ?SetDepartureCityAction,
  title: string,
  dataSelector: string,
};

const defaultProps: $Shape<Props> = {
  departureCities: [],
  departureCity: '',
  setDepartureCity: noop,
  title: '',
  dataSelector: 'BookingOptionsDepartureCities',
};

export class DepartureCities extends React.Component<Props> {
  static defaultProps: $Shape<Props>;

  getDepartureCitiesOptions = (): Array<{
    value: string,
    label: string,
  }> => {
    return this.props.departureCities.map(departureCityToMap => ({
      value: get(departureCityToMap, 'value'),
      label: get(departureCityToMap, 'name'),
    }));
  };

  handleChange = (value: string) => {
    this.props.setDepartureCity(value);
  };

  render() {
    return (
      <BlockField icon={ICONS.TRANSPORT} title={this.props.title}>
        <FormSelect
          value={this.props.departureCity}
          hasNoField
          onChange={this.handleChange}
          options={this.getDepartureCitiesOptions()}
        />
      </BlockField>
    );
  }
}

DepartureCities.defaultProps = defaultProps;
